var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "YouTube",
    clipPath: "url(#clip0_5108_12650)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6014 5.15313C19.4883 4.72764 19.2654 4.33931 18.9551 4.027C18.6448 3.7147 18.2579 3.48938 17.8332 3.37358C16.2695 2.95313 10.0195 2.95312 10.0195 2.95312C10.0195 2.95312 3.76953 2.95313 2.20589 3.37358C1.78114 3.48938 1.39425 3.7147 1.08394 4.027C0.773628 4.33931 0.550786 4.72764 0.437713 5.15313C0.0195313 6.72358 0.0195312 9.99858 0.0195312 9.99858C0.0195312 9.99858 0.0195313 13.2736 0.437713 14.844C0.550786 15.2695 0.773628 15.6578 1.08394 15.9702C1.39425 16.2825 1.78114 16.5078 2.20589 16.6236C3.76953 17.044 10.0195 17.044 10.0195 17.044C10.0195 17.044 16.2695 17.044 17.8332 16.6236C18.2579 16.5078 18.6448 16.2825 18.9551 15.9702C19.2654 15.6578 19.4883 15.2695 19.6014 14.844C20.0195 13.2736 20.0195 9.99858 20.0195 9.99858C20.0195 9.99858 20.0195 6.72358 19.6014 5.15313Z",
    fill: "#FF0302"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.97461 12.9751V7.02734L13.2019 10.0012L7.97461 12.9751Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5108_12650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube2);
export default __webpack_public_path__ + "static/media/YouTube2.1b209aba3299a158d7b25ac5ac8ca115.svg";
export { ForwardRef as ReactComponent };